// (c) chaehongee. Confidential and proprietary.

export interface Env {
    apiBaseUrl: string
    supabaseUrl: string
    supabaseAnonKey: string
    supabaseTrainingBucket: string
}

export function getEnv(): Env {
    const viteBase = import.meta.env.VITE_API_BASE_URL as string | undefined
    const supabaseUrl =
        (import.meta.env.VITE_SUPABASE_URL as string | undefined) ||
        'https://oijmzwyzkurqizakiieg.supabase.co'
    const supabaseAnonKey =
        (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ||
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9pam16d3l6a3VycWl6YWtpaWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIyMDgyMzAsImV4cCI6MjA3Nzc4NDIzMH0.vd9tCNF4ryzBpbF_W-LW373GYKINc-7H_3xdqPo2AAM'
    const supabaseTrainingBucket =
        (import.meta.env.VITE_SUPABASE_TRAINING_BUCKET as string | undefined) ||
        'lora-training-data'

    // Prefer explicit env when provided
    if (viteBase && viteBase.trim().length > 0) {
        return {
            apiBaseUrl: viteBase.replace(/\/$/, ''),
            supabaseUrl,
            supabaseAnonKey,
            supabaseTrainingBucket,
        }
    }
    // Fallbacks:
    // - Local dev: point to local FastAPI
    // - Production: use same-origin and rely on platform rewrite for /api/v1/*
    if (typeof window !== 'undefined') {
        const host = window.location.hostname
        if (host === 'localhost' || host === '127.0.0.1') {
            return {
                apiBaseUrl: 'http://localhost:8000/api/v1',
                supabaseUrl,
                supabaseAnonKey,
                supabaseTrainingBucket,
            }
        }
        return { apiBaseUrl: '/api/v1', supabaseUrl, supabaseAnonKey, supabaseTrainingBucket }
    }
    // Non-browser default (SSR/build): same-origin relative
    return { apiBaseUrl: '/api/v1', supabaseUrl, supabaseAnonKey, supabaseTrainingBucket }
}

export function isDev(): boolean {
    if (typeof window === 'undefined') {
        return false
    }
    const host = window.location.hostname
    return host === 'localhost' || host === '127.0.0.1'
}


